import Vue from 'vue'
import { HappyScroll } from '@/components/vue-scroll'
import {
  Autocomplete,
  Button,
  Carousel,
  CarouselItem,
  Checkbox,
  CheckboxGroup,
  Col,
  DatePicker, Dialog, Dropdown, DropdownItem, DropdownMenu,
  Form, FormItem, Input, Loading, Message, MessageBox,
  Option,
  Pagination,
  Row, Select, Table, TableColumn,
  Tooltip,
  Upload,
} from 'element-ui'

Vue.use(Autocomplete)
Vue.use(Button)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Col)
Vue.use(DatePicker)
Vue.use(Dialog)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Loading)
Vue.use(Option)
Vue.use(Pagination)
Vue.use(Row)
Vue.use(Select)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tooltip)
Vue.use(Upload)

Vue.component('happy-scroll', HappyScroll)

Vue.prototype.$message = Message
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$loading = () => {
  Vue.prototype.$loaded = Loading.service()
}
